import { User } from './User';
import { Workspace } from './Workspace';

export enum SessionLoginMethod {
    GOOGLE = 'Google',
    MICROSOFT = 'Microsoft',
    MAGIC = 'Magic Link',
    PASSKEY = 'Passkey',
    SSO = 'SSO',
}

export enum SessionApplicationType {
    WEB = 'Web',
    MAC = 'Mac',
    WINDOWS = 'Windows',
}

export interface Session {
    id: string;
    user?: User;
    workspace?: Workspace;
    fingerprint?: string;
    ipAddress?: string;
    location?: string;
    browser?: string;
    os?: string;
    deviceType?: string;
    userAgentRaw?: string;
    loginMethod: SessionLoginMethod;
    applicationType: SessionApplicationType;
    isCurrent: boolean;
    isRevoked: boolean;
    revokedAt?: Date;
    lastSeenAt?: Date;
    expiresAt?: Date;
    createdAt: Date;
    updatedAt: Date;
}

export type RevokeSessionResponse = {
    id: string;
    wasCurrent: boolean;
};

export type RevokeOtherSessionsResponse = {
    revokedSessionCount: number;
};
